<template>
  <tr>
    <td>
      <div class="form-field">
        <div class="form-group">
          <input-field
            :id="'codigo_barra' + index"
            v-model="modelValue.codigo_barra"
            :readonly="modelValue.item_id != ''"
            @keyup.enter="consultarCodigoBarra"
            placeholder="Escriba un código de barra..."
          ></input-field>
          <button
            type="button"
            v-show="modelValue.item_id == ''"
            @click="consultarCodigoBarra"
            class="btn-success btn--text"
          >
            <i class="fa fa-check"></i>
          </button>
          <!-- <button
            v-show="modelValue.item_id != '' && editable"
            type="button"
            @click="quitarItem"
            class="btn-danger btn--text"
          >
            <i class="fa fa-times"></i>
          </button> -->
        </div>
      </div>
    </td>
    <td>
      <div
        class="form-field select2"
        :class="{
          'select2--disabled': true,
        }"
      >
        <div class="select2-field">
          <v-select
            @input="inputItem"
            :options="items"
            label="nombre"
            :id="'item' + index"
            v-model="selectedItem"
            @search="searchItem"
          ></v-select>
        </div>
      </div>
    </td>
    <td>
      <div class="form-field">
        <input-field
          :id="'cantidad' + index"
          v-model="modelValue.cantidad"
          vMoney
          :format="decimal"
          readonly
        ></input-field>
      </div>
    </td>
    <td>
      <!-- <button
        v-show="editable"
        @click="eliminar"
        type="button"
        class="btn-danger btn--text"
      >
        <i class="fa fa-trash"></i>
      </button> -->
    </td>
  </tr>
</template>

<script>
export default {
  props: {
    editable: {
      type: Boolean,
      required: false,
      default: true,
    },
    index: {
      type: Number,
      required: true,
    },
    value: {
      type: Object,
      required: false,
      default: function () {
        return {};
      },
    },
  },
  data: function () {
    return {
      selectedItem: null,
      items: [],
      modelValue: this.value,
      decimal: decimal,
    };
  },
  methods: {
    searchItem: function (search, loading) {
      loading(true);
      let that = this;
      let xmlhttp = new XMLHttpRequest();
      xmlhttp.onreadystatechange = function () {
        if (
          (this.readyState == 4 && this.status == 200) ||
          this.status == 201
        ) {
          let json = JSON.parse(this.responseText);
          that.items = json;
          loading(false);
        } else loading(false);
      };
      xmlhttp.open("GET", url + "/search/items?search=" + search, true);
      xmlhttp.send();
    },
    quitarItem: function () {
      this.modelValue.item_id = "";
      this.selectedItem = null;
      this.modelValue.codigo_barra = "";
    },
    inputItem: function () {
      if (this.selectedItem != null) {
        this.modelValue.item_id = this.selectedItem.id;
        this.modelValue.codigo_barra = this.selectedItem.codigo_barra;
      } else {
        this.modelValue.item_id = "";
        this.modelValue.codigo_barra = "";
      }
    },
    consultarCodigoBarra: function () {
      axios
        .get(url + "/inventario/codigo-barra", {
          params: {
            codigo_barra: this.modelValue.codigo_barra,
          },
        })
        .then(({ data }) => {
          this.selectedItem = data;
          this.modelValue.item_id = this.selectedItem.id;
        })
        .catch(() => {
          swal(
            "El código de barra no se encuentra registrado.",
            "Aviso",
            "warning"
          );
        });
    },
    eliminar: function () {
      this.$emit("eliminar", this.index);
    },
  },
  mounted: function () {
    if (this.modelValue.item_id != "") {
      this.selectedItem = {
        id: this.modelValue.item_id,
        nombre: this.modelValue.nombre_item,
      };
    }
  },
};
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/forms/logistica/visitas/TrItemVisita.vue